import React from "react";

import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="col-900">
        <div className="copyright">
          &copy; 2020 New Face - Desarrollado por {" "}
          <a
            href="mailto:pupi_marti@hotmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
             Juan A. Martí
          </a>
        </div>
        <ul className="menu">
          <li className="item">
            <a
              href="https://www.facebook.com/newface.dolores.54"
              rel="noopener noreferrer"
              target="_blank"
            >
              Facebook
            </a>
          </li>
          <li className="item">
            <a
              href="https://www.instagram.com/newfacedolores/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Instagram
            </a>
          </li>
          <li className="item">
            <a
              href="https://api.whatsapp.com/send?phone=5492245427854"
              rel="noopener noreferrer"
              target="_blank"
            >
              Whatsapp
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
